import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { MaintenanceOrderNoteModel } from 'src/app/models/maintenance/maintenance-order-note.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceOrderNoteService {

  constructor(private _httpClient: HttpClient) { }

  createMaintenanceOrderNote(maintenanceOrderNoteContractModel: MaintenanceOrderNoteModel): Observable<MaintenanceOrderNoteModel> {
    return this._httpClient.post<MaintenanceOrderNoteModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceOrderNote.CreateAsync}`,
      maintenanceOrderNoteContractModel);
  }

  deleteMaintenanceOrderNote(maintenanceOrderNoteId: number): Observable<MaintenanceOrderNoteModel> {
    return this._httpClient.delete<MaintenanceOrderNoteModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceOrderNote.DeleteAsync}/${maintenanceOrderNoteId}`);
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams()
      .set('columnSort', columnSort ?? '')
      .set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceOrderNote.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllMaintenanceOrderNotesForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceOrderNote.GetAllMaintenanceOrderNotesForSelectAsync}`,);
  }

  getAllMaintenanceOrderNotesWithPagination(maintenanceOrderId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    let params = new HttpParams()
      .set('maintenanceOrderId', maintenanceOrderId)
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceOrderNote.GetAllMaintenanceOrderNotesWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceOrderNote.GetColumnsForGeneralConsultationAsync}`);
  }

  getMaintenanceOrderNoteById(maintenanceOrderNoteId: number): Observable<MaintenanceOrderNoteModel> {
    return this._httpClient.get<MaintenanceOrderNoteModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceOrderNote.GetByIdAsync}/${maintenanceOrderNoteId}`);
  }

  updateMaintenanceOrderNote(maintenanceOrderNoteContractModel: MaintenanceOrderNoteModel): Observable<MaintenanceOrderNoteModel> {
    return this._httpClient.put<MaintenanceOrderNoteModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceOrderNote.UpdateAsync}`,
      maintenanceOrderNoteContractModel);
  }

}
